export default "__VITE_ASSET__CiS$tCvs__"